import { useEffect, useRef } from "react";
import "@/App.css";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import ApproachSection from "./components/ApproachSection";
import MentorSection from "./components/MentorSection";
import BatchSection from "./components/BatchSection";
import OfferingsSection from "./components/OfferingsSection";
import FAQSection from "./components/FAQSection";
import RegistrationSection from "./components/RegistrationSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    const sections = document.querySelectorAll(".section-animate");
    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="app-container">
      <Navbar />
      <HeroSection />
      <div className="section-animate">
        <ProblemSection />
      </div>
      <div className="section-animate">
        <ApproachSection />
      </div>
      <div className="section-animate">
        <MentorSection />
      </div>
      <div className="section-animate">
        <BatchSection />
      </div>
      <div className="section-animate">
        <OfferingsSection />
      </div>
      <div className="section-animate">
        <FAQSection />
      </div>
      <div className="section-animate">
        <RegistrationSection />
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
